<template>
  <div>
    <div v-if="is_h5 == false">
      <!-- <el-scrollbar wrap-style="overflow-x:hidden;" :style="{height:getScreenHeight()}"> -->
      <div ref="pageContentRef" v-loading="loading" class="page-content">
        <el-row :gutter="20">
          <el-col :span="spanValue" class="col" v-for='(item, idx) in tableData' :key="idx" :label="idx">
            <div class="xbox"  @click="toggleMediaDisplay(idx)">
              <div style="height: calc(100% * 2/3);">
                <el-image v-show="undefined == item.show || item.show != 'video'" style="height: 100%; width: 100%;" :src="getImageSource(item.cover_image)" fit="contain" ref="imageRef">
                </el-image>
              </div>
              <div class="text" style="height: calc(100% * 1/3); background-color: white; min-height: 80px;">
                <div class="title">{{ item.name}}</div>
                <div v-if="item.kc_url">
                  <div class="source">
                    <div>{{ ' ' + displayOrgName(item) }}</div>
                  </div>
                  <div>
                    <span style="float: left;"><el-icon><User /></el-icon>{{ ' ' + (item.username || item.sys_username) }}</span>
                    <span style="float: right;"><el-icon><View /></el-icon>{{' ' + (item.read_count || 0)}}</span>
                  </div>
                </div>
                <div v-else>
                  <div class="source">
                    <div>{{ ' ' + displayOrgName(item, { onlySysOrg: true }) }}</div>
                  </div>
                  <div>
                    <span style="float: left;"><el-icon><User /></el-icon>{{ ' ' + (item.username || item.sys_username) }}</span>
                    <span style="float: right;"><el-icon><View /></el-icon>{{' ' + (item.read_count || 0)}}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="row">
          <el-col :span="24">
            <div class="pagination-container">
              <el-pagination
                  :hide-on-single-page="hideOnSinglePage"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="CurrentPageNo"
                  :page-sizes="PageSizes"
                  :page-size="PageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="Total">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- </el-scrollbar> -->
    </div>
    <div v-else>
      <div v-loading="loading" :style="{'margin-top':is_top?'105px':'48px'}">
          <van-list v-model:loading="loading_h5" :finished="finished" finished-text="没有更多了" @load="onLoad" offset="100">
            <van-grid :border="false" :column-num="2" :gutter="4" :clickable="true">
              <van-grid-item v-for='(item, idx) in tableData' :key="idx" :label="idx" @click="toggleMediaDisplay(idx)">
                <van-image
                  :src="getImageSource(item.cover_image)"
                />
                <div style="width: 100%;font-size: 14px; text-align: left;">
                  <div class="van-multi-ellipsis--l2" >
                    {{ item.name}}
                  </div>
                  <div style="margin-top: 10px; font-size: 10px; color: #969799;">
                    <span style="float: left;"><van-icon name="user-o" />{{ ' ' + displayOrgName(item) }} / {{ ' ' + (item.username || item.sys_username) }}</span>
                    <span style="float: right;"><van-icon name="play-circle-o" />{{' ' + (item.read_count || 0)}}</span>
                  </div>
                </div>
              </van-grid-item>
            </van-grid>
          </van-list>
      </div>
    </div>
    <div id="showVideo">
      <more-attachment v-if="showMoreAttachment" ref="attachmentRef" :item="item" :title="title" v-on:close_dialog="closeAttachmentRefDialog"></more-attachment>
    </div>
  </div>
</template>

<script>
import {showNotify} from 'vant';
import { ref } from 'vue';
import moreAttachment from "@/components/more-attachment.vue";
export default {
  name: "searchPage",
  components: {
    moreAttachment
  },
  props: {
    searchParam: {
      type: Object,
      default: () => {},
    },
    is_top: {
      type: Boolean,
      default: () => false,
    },
    is_h5: {
      type: Boolean,
      default: () => false,
    },
    get_search_page_data: {
      type: String,
      default: () => '',
    },
    /**
     * PC 栅格列宽下限（el-col :span，数值越大单列越宽、每行张数越少）。
     * 默认不传：与首页一致，仅用 calculateSpan()。仅在嵌入极窄容器且希望少列时可传入较大值（如 6）。
     */
    minColumnSpan: {
      type: Number,
      default: null,
    },
    /**
     * PC 下列数推算所依据的宽度：window=视口（与首页一致）；container=本组件 .page-content 实际宽度（适合专业详情左侧栏占位后的主栏）。
     */
    spanBasis: {
      type: String,
      default: 'window',
      validator: (v) => v === 'window' || v === 'container',
    },
  },
  setup() {
    const loading_h5 = ref(false);
    const finished = ref(false);
    const apiUrls = {
      'getSearchPageData':'/onlineCodeService/jxzysjfl_api/loadSearchPageData',
    };

    return {
      loading_h5,
      finished,
      isLoading: ref(true),
      apiUrls
    }
  },
  data() {
    return {
      spanValue:4,
      loading: false,
      hideOnSinglePage: false,
      CurrentPageNo: 1,
      isPage: true,
      PageSize: 10,
      PageSizes:[10, 20, 50, 100, 200],
      Total: 0,
      tableData:[],
      item:{},
      showMoreAttachment: false,
      spanResizeObs: null,
      spanResizeRafId: null,
    };
  },
  created() {
  },
  beforeUnmount() {
    this.unbindSpanWidthObserver();
    window.removeEventListener('resize', this.windowResize);
  },
  mounted() {
    window.addEventListener('resize', this.windowResize);
    this.$nextTick(() => {
      this.bindSpanWidthObserver();
      this.windowResize();
    });
  },
  methods: {
    normalizeOrgSegments(rawVal) {
      const out = []
      if (Array.isArray(rawVal)) {
        rawVal.forEach((v) => {
          const s = v == null ? '' : String(v)
          if (!s) return
          s.split('/').forEach((seg) => {
            const t = seg == null ? '' : String(seg).trim()
            if (t) out.push(t)
          })
        })
        return out
      }
      if (rawVal == null) return out
      String(rawVal)
        .split('/')
        .forEach((seg) => {
          const t = seg == null ? '' : String(seg).trim()
          if (t) out.push(t)
        })
      return out
    },
    displayOrgName(item, opts = {}) {
      const onlySysOrg = opts.onlySysOrg === true
      const orgSegments = onlySysOrg ? [] : this.normalizeOrgSegments(item && item.orgname)
      const sysOrgSegments = this.normalizeOrgSegments(item && item.sys_org_name)
      if (orgSegments.length) {
        return orgSegments[orgSegments.length - 1]
      }
      if (sysOrgSegments.length) {
        return sysOrgSegments[0]
      }
      return ''
    },
    getScreenHeight(){
      var screenHeight = this.$utils.getScreenHeight()
      return (screenHeight - 220) + 'px'
    },
    /** 专业详情等场景：按列表容器实际宽度推算 span，避免与全窗首页同一套宽度 */
    spanBasisWidthPx() {
      if (this.spanBasis !== 'container' || this.is_h5) {
        return null;
      }
      const el = this.$refs.pageContentRef;
      const w = el && typeof el.clientWidth === 'number' ? el.clientWidth : 0;
      return w > 80 ? w : null;
    },
    bindSpanWidthObserver() {
      this.unbindSpanWidthObserver();
      if (this.spanBasis !== 'container' || this.is_h5) return;
      const el = this.$refs.pageContentRef;
      if (!el || typeof ResizeObserver === 'undefined') return;
      // 推迟到下一帧，避免 ResizeObserver 与布局互触发的 loop 警告
      this.spanResizeObs = new ResizeObserver(() => {
        if (this.spanResizeRafId != null) {
          cancelAnimationFrame(this.spanResizeRafId);
        }
        this.spanResizeRafId = requestAnimationFrame(() => {
          this.spanResizeRafId = null;
          this.windowResize();
        });
      });
      this.spanResizeObs.observe(el);
    },
    unbindSpanWidthObserver() {
      if (this.spanResizeRafId != null) {
        cancelAnimationFrame(this.spanResizeRafId);
        this.spanResizeRafId = null;
      }
      if (this.spanResizeObs) {
        this.spanResizeObs.disconnect();
        this.spanResizeObs = null;
      }
    },
    windowResize() {
      const bw = this.spanBasisWidthPx();
      let s = this.$utils.calculateSpan(bw == null ? undefined : bw);
      if (
        this.minColumnSpan != null &&
        this.minColumnSpan > 0 &&
        s < this.minColumnSpan
      ) {
        s = this.minColumnSpan;
      }
      this.spanValue = s;
      this.PageSize = (24 / this.spanValue) * 2;
      this.initPageSize();
    },
    handlePlayerSeeking(idx){
      /* 监听手动改变播放时间操作 */
      console.log(idx)
    },
    updatePlayerTime(idx) {
      /* 实时获取视频的播放时间 */
      console.log(idx)
    },
    toggleMediaDisplay(idx){
      this.item = this.tableData[idx]
      let routeUrl = this.$router.resolve({
        path: "Detail",
        query: {
          _id:this.item._id
        }
      });
      if (this.is_h5){
        if (this.item.open_method == '直接跳转'){
          window.location.href = this.$utils.buildCourseSsoUrl(this.item.kc_url, this.item.kc_source)
          return false;
        }
        window.location.href = routeUrl.href
      }else{
        if (this.item.open_method == '直接跳转'){
          window.open(this.$utils.buildCourseSsoUrl(this.item.kc_url, this.item.kc_source), '_blank');
          return false;
        }
        this.$utils.windowOpen(routeUrl.href)
      }
    },
    getVideoSource(url){
      return window.baseURL + url
    },
    initPageSize(){
      if (this.PageSize < 0){
        this.PageSize = 10
      }
      this.init()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.PageSize = val
      this.loadTableData()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.CurrentPageNo = val
      this.loadTableData()
    },
    init(){
      if (this.is_h5 == false){
        this.loadTableData()  
      }
    },
    loadTableData() {
      this._loadSeq = (this._loadSeq || 0) + 1
      const seq = this._loadSeq
      const requestedPage = this.CurrentPageNo

      this.loading = true
      this.loading_h5 = false
      let param = {}
      param['isPage'] = this.isPage
      param['CurrentPageNo'] = this.CurrentPageNo
      param['PageSize'] = this.PageSize
      param['QueryObject'] = this.searchParam

      let getSearchPageDataAPI = this.apiUrls.getSearchPageData
      if (this.get_search_page_data.length > 0){
        getSearchPageDataAPI = this.get_search_page_data
      }
      this.$http.post(getSearchPageDataAPI, param).then(res => {
        if (seq !== this._loadSeq) {
          return
        }
        this.loading = false
        if ('0' == res.resultCode) {
          let resultData = res.resultData;
          const list = resultData['DataList'] || []
          if(this.is_h5 == false){
            this.tableData = list
          }else{
            if (requestedPage === 1) {
              this.tableData = list
            } else {
              this.tableData = [...this.tableData, ...list]
            }
          }
          this.CurrentPageNo = resultData['CurrentPageNo']
          this.PageSize = resultData['PageSize']
          this.Total = resultData['Total']

          if (Math.ceil(this.Total / this.PageSize) < this.CurrentPageNo){    
            this.finished = true;        
            this.CurrentPageNo = Math.ceil(this.Total / this.PageSize)
            if(this.is_h5 == false){
              this.loadTableData()
            }
          }
        } else {
          this.tableData = []
          window.vueAlter(res.resultMsg, 'warning')
        }
      }).catch(error => {
        if (seq !== this._loadSeq) {
          return
        }
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
        this.tableData = []
        this.loading = false
      })
    },
    closeAttachmentRefDialog(){
      this.showMoreAttachment = false
    },
    getImageSource(img){
      if (undefined != img && !img.startsWith("http")){
        return this.$utils.getImageSource(img)
      }else{
        return img
      }
    },
    
    onLoad() {
      console.log('onLoad', this.loading)
      if (this.tableData.length > 0){
        this.CurrentPageNo +=1
      }

      this.loadTableData()
    },
  },
  watch: {
    searchParam: {
      handler() {
        // 切换条件时不立即清空列表，避免布局塌陷闪屏；新数据返回后再替换（见 loadTableData）
        this.CurrentPageNo = 1
        this.finished = false
        this.loadTableData()
      }
    },
    spanBasis() {
      this.$nextTick(() => {
        this.bindSpanWidthObserver()
        this.windowResize()
      })
    },
    is_h5() {
      this.$nextTick(() => {
        this.bindSpanWidthObserver()
        this.windowResize()
      })
    },
  }
};
</script>

<style scoped>
.page-content {
  padding: 12px 4px 16px;
  overflow-x: hidden;
}

.page-content .row {
  padding-bottom: 20px;
}

.page-content .col {
  padding-bottom: 20px;
}

.page-content .xbox {
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(23, 92, 196, 0.08);
  box-shadow: 0 4px 20px rgba(23, 92, 196, 0.06);
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.page-content .xbox:hover {
  border-color: rgba(23, 92, 196, 0.18);
  box-shadow: 0 10px 36px rgba(23, 92, 196, 0.12);
  transform: translateY(-2px);
}

.page-content .xbox .text {
  padding: 16px 14px 18px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.45;
}

.page-content .xbox .title {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.page-content .xbox .source {
  margin: 8px 0 12px;
  font-size: 12px;
  color: #94a3b8;
}

.page-content .xbox .text .el-icon {
  vertical-align: -2px;
  color: #94a3b8;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.van-grid-item__content--clickable {
  border-radius: 10px; /* 设置圆角半径为10px，根据需要调整 */
}
</style>
